export default "__VITE_ASSET__DKI5D6GD__"